import { arrayReorder } from '../../../../core/util/array-reorder';
import { Control } from '../../../../vas/business-objects/control/control.model';
import { ComplexControl } from '../../../../vas/controls/complex/complex-control.model';
import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';

export const controlFormSubControlReorderReducer = (
    state = initialState,
    action: actions.ControlFormSubControlReorder
): State => {
    return {
        ...state,
        controlForm: {
            control: (() => {
                let controls = [
                    ...(state.controlForm.control as ComplexControl).config.controls
                ];
                controls = arrayReorder(controls, action.payload);
                controls = controls
                    .map((c, sequence) =>
                        new Control({...c, sequence})
                    );

                return new ComplexControl({
                    ...state.controlForm.control,
                    config: {
                        ...state.controlForm.control.config,
                        controls
                    }
                });
            })()
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/control-form-sub-control-reorder.reducer.ts